<section class="tw-pb-2 tw-p-4 tw-m-4 tw-shadow-[0_2px_4px_0_rgba(0,0,0,0.10)] tw-rounded-xl tw-overflow-hidden" style="background: white !important">
  <div class="tw-flex tw-gap-4 tw-mb-4" *ngIf="showReorderKitHeader">
    <span class="tw-relative tw-inline-block">
        <img alt="dr" class="tw-flex-none tw-h-12 tw-w-12 tw-rounded-full" [src]="userDrImage" />
        <img alt="tick" src="/assets/icons/orange_tick_new.svg" class="tw-absolute tw-top-[2px] tw-right-[-1px] tw-h-4 tw-w-4">
    </span>
    <span>
      <h2 class="tw-font-bold tw-text-500 tw-text-black tw-tracking-normal" [class]="isShopRevampExperimentOn ? 'tw-font-lexend' : 'tw-font-body'" i18n="@@reorderYourKit">Reorder your kit</h2>
      <p class="tw-font-body tw-text-300 tw-text-gray-500" i18n="@@toAvoidGapsInTreatment">To avoid gaps in your treatment</p>
    </span>
  </div>
  <div class="tw-flex tw-gap-6 tw-mb-4" *ngIf="showCompleteOrderHeader">
      <span>
          <h2 class="tw-font-bold tw-text-500 tw-text-gray-800 tw-tracking-normal" [class]="isShopRevampExperimentOn ? 'tw-font-lexend' : 'tw-font-body'" i18n="@@completeOrder">
              Complete your order
          </h2>
          <p *ngIf="this.productsInCart[0].quantity === 1" class="tw-font-body tw-text-300 tw-text-gray-500" i18n="@@oneProductInCart">
              1 Product in your cart
          </p>
          <p *ngIf="this.productsInCart[0].quantity > 1" class="tw-font-body tw-text-300 tw-text-gray-500" i18n="@@multipleProductsInCart">
              {{this.productsInCart[0].quantity}} Products in your cart
          </p>
      </span>
  </div>
  <div class="tw-flex tw-gap-4 tw-mb-4" id="doctorAddedSection" *ngIf="showDoctorAddedHeader">
    <span class="tw-relative tw-inline-block">
        <img alt="dr" class="tw-flex-none tw-h-12 tw-w-12 tw-rounded-full" [src]="userDrImage" />
        <img alt="tick" src="/assets/icons/orange_tick_new.svg" class="tw-absolute tw-top-[2px] tw-right-[-1px] tw-h-4 tw-w-4" id="tick">
    </span>
    <span>
        <h2 class="tw-font-bold tw-text-500 tw-text-gray-800 tw-tracking-normal" [class]="isShopRevampExperimentOn ? 'tw-font-lexend' : 'tw-font-body'" i18n="@@drAddedProducts">
          Doctor-added products
        </h2>
        <p class="tw-font-body tw-text-300 tw-text-gray-500" i18n="@@basisCheckupReport">
          Based on your checkup report
        </p>
    </span>
</div>
  <div class="tw-flex tw-bg-white tw-rounded-2 tw-border-2 tw-border-gray-100 tw-mb-4 tw-relative tw-overflow-hidden" (click)="handleClick()">
        <div class="tw-flex-none tw-flex tw-justify-center tw-items-center tw-box-content tw-w-2/5">
          <img alt="product" class="tw-h-[144px] tw-max-w-full tw-max-h-full tw-min-w-full tw-min-h-full" [src]="productsInCart[0]?.rebrandedImageWithBackground || productsInCart[0]?.productUnboxedImage || productsInCart[0]?.rebrandedImageWithoutBackground" />
        </div>
        <div class="tw-pl-4 tw-pr-4 tw-flex tw-flex-col tw-items-start tw-relative tw-pb-4 tw-pt-4" (click)="handleClick()">
          <p class="tw-text-300 tw-text-gray-800 tw-tracking-normal tw-mb-2" [class]="isShopRevampExperimentOn ? 'tw-font-lexend' : 'tw-font-body'">
              {{productsInCart[0]?.product?.title || productsInCart[0]?.title}}
          </p>
          <p class="tw-text-300 tw-tracking-normal" [class]="isShopRevampExperimentOn ? 'tw-font-lexend' : 'tw-font-body'">
              <span class="tw-relative tw-inline-block">
              <span class="tw-relative z-10 tw-text-gray-400">&ngsp;&ngsp; ₹{{productsInCart[0]?.mrp}}&ngsp;</span>
                <span class="tw-absolute tw-top-1/2 tw-left-0 tw-right-0 tw-h-[1px] tw-bg-gray-400 tw-w-[90%] tw-mx-auto"></span>
              </span>
              <span class="tw-font-bold tw-text-orange-400">&nbsp;₹{{productsInCart[0]?.price}}</span>
          </p>
      </div>
      <div *ngIf="productsInCart[0]?.isDoctorAdded" class="tw-absolute tw-bottom-0 tw-left-0 tw-w-full tw-text-center tw-gap-2 tw-bg-orange-100 tw-flex tw-items-center tw-justify-center">
        <cs-icon class="tw-h-3 tw-w-3 tw-text-bold tw-text-orange-400" [iconName]='"done"'></cs-icon>
            <p class="tw-text-orange-400 tw-text-100 tw-whitespace-nowrap" [class]="isShopRevampExperimentOn ? 'tw-font-lexend' : 'tw-font-body'" i18n="@@drAdded">
               Dr. Added
            </p>
      </div>
  </div>
  <button csButton
          id="cartSingleProductBannerBuyNowButton"
          type="button"
          class="tw-w-full tw-h-10 tw-gap-4 tw-justify-normal tw-overflow-visible tw-mb-2 tw-shadow-[0_2px_4px_0_rgba(0,0,0,0.10)]"
          (click)="handleClick()">
    <div class="shine loop tw-absolute tw-inset-0 tw-bg-gradient-to-r tw-from-transparent tw-via-white/50 tw-to-transparent tw-pointer-events-none"></div>
    <div class="tw-flex tw-items-center tw-justify-center tw-text-orange-400">
      <cs-icon class="tw-relative tw-w-[56px] tw-h-[56px] tw-animate-spin_slow" [iconName]='"rebranded-orange-discount"'></cs-icon>
      <div class="tw-absolute tw-uppercase tw-font-bold tw-z-0 tw-leading-4 tw-text-300 tw-text-white" [class]="isShopRevampExperimentOn ? 'tw-font-lexend' : 'tw-font-body'">
        <span>{{ cartDiscount }}%</span> <br /> <span i18n="@@off" class="tw-text-200">Off</span>
      </div>
    </div>
    <span class="tw-text-300 tw-font-bold tw-tracking-normal tw-normal-case" [class]="isShopRevampExperimentOn ? 'tw-font-lexend' : 'tw-font-body'">
      <span i18n="@@buyNow">Buy Now</span><span>&nbsp;&#64; ₹{{ totalSp }}</span>
    </span>
  </button>
</section>
